// removed by extract-text-webpack-plugin
module.exports = {"container":"_2-vZDZYvLZqZB-SE-8ygXx"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/Filler/styles.css
// module id = 3134
// module chunks = 0